module.exports = __webpack_public_path__ + "img/Business_item_1.0faee629.jpg";